var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"my-6 pl-4 pr-8",attrs:{"dense":"","type":"number","headers":_vm.headers,"items":_vm.customItems || _vm.items,"item-key":"tote_id","hide-default-footer":"","mobile-breakpoint":"300"}})
}
var staticRenderFns = []

export { render, staticRenderFns }